import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import { CartResponse, } from 'common/types';

class CartItemRepository extends BaseRepositoryClass implements RepositoryType {
    private _prepareUrl(token: string, identifier: number) {
        return `${this.apiVersion}/grant/cart/${token}/item/${identifier}`;
    }

    remove(token: string, identifier: number) {
        const url = this._prepareUrl(token, identifier);

        return this
            .requester
            .delete<CartResponse>(url);
    }

    update(token: string, identifier: number, quantity: number) {
        const url = this._prepareUrl(token, identifier);
        const data = { quantity, };

        return this
            .requester
            .put<CartResponse>(url, data);
    }
}

export default CartItemRepository;
